import { createEntityStore, createKeyedCache } from '@redpanda/utils';
import { toast } from 'react-hot-toast';
import { getAttendanceRecords, deleteAttendanceRecord, getLeaveRequests, deleteLeaveRequest, getAttendanceSummary } from '../services/api';
import { storeMessages } from './storeMessages';

export interface EmployeeRef {
  id: string;
  name: string;
  employeeNumber?: string | null;
  department?: string | null;
}

export interface AttendanceRecord {
  id: string;
  employeeId: string;
  date: string;
  checkInTime?: string | null;
  checkOutTime?: string | null;
  workHours?: number | null;
  overtimeHours?: number | null;
  status?: string | null;
  notes?: string | null;
  employee?: EmployeeRef;
}

export interface LeaveRequest {
  id: string;
  employeeId: string;
  leaveType: string;
  startDate: string;
  endDate: string;
  days: number;
  reason?: string | null;
  status: string; // PENDING, APPROVED, REJECTED
  employee?: EmployeeRef;
}

interface AttendanceSummary {
  totalRecords: number;
  present: number;
  leave: number;
  absent: number;
  late: number;
  missingCheck: number;
}

export const useAttendanceStoreBase = createEntityStore<AttendanceRecord>({
  entityName: 'attendanceRecord',
  fetchFn: (page: number) => getAttendanceRecords(page),
  deleteFn: deleteAttendanceRecord,
  toast,
  messages: storeMessages,
});

export const useLeaveStoreBase = createEntityStore<LeaveRequest>({
  entityName: 'leaveRequest',
  fetchFn: (page: number) => getLeaveRequests(page),
  deleteFn: deleteLeaveRequest,
  toast,
  messages: storeMessages,
});

/** 本月出勤摘要（persist：進頁面先顯示上次的數字再背景更新） */
export const useAttendanceSummary = createKeyedCache<{ startDate: string; endDate: string }, AttendanceSummary>(
  'attendance-summary',
  async ({ startDate, endDate }) => (await getAttendanceSummary(startDate, endDate)).data,
);

/** 待審核請假數（請假分頁標籤上的數字） */
export const usePendingLeaveCount = createKeyedCache<'pending', number>(
  'pending-leave-count',
  async () => (await getLeaveRequests(1, { status: 'PENDING', pageSize: 1 })).data.pagination?.totalItems ?? 0,
);
